import { render, staticRenderFns } from "./Xhold.vue?vue&type=template&id=3c65cb22&"
import script from "./Xhold.vue?vue&type=script&lang=js&"
export * from "./Xhold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports